import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import ContentfulClient, { PreviewClient } from "lib/Contentful";
import ApiClient, { ClientId } from "lib/ApiClient";
import { client as Apollo } from "lib/Apollo";

import { fetchGlobalSettings } from "state/actions/ui/applicationUIActions";
import {
  fetchShopifyProducts,
  fetchContentfulProducts
} from "state/actions/productsActions";
import { fetchOrCreateCheckout } from "state/actions/checkoutActions";

export const initializeApplication = (
  checkoutId: string,
  isPreview: boolean
) => (dispatch: ThunkDispatch<{}, {}, AnyAction>) =>
  dispatch({
    type: "INITIALIZE_APPLICATION",
    payload: new Promise((resolve, reject) => {
      let Contentful;
      try {
        Contentful = isPreview ? PreviewClient() : ContentfulClient();
      } catch (e) {
        reject(e);
        return;
      }

      ApiClient.setRef(ClientId.CONTENTFUL, Contentful);
      ApiClient.setRef(ClientId.APOLLO, Apollo);

      const initApp = Promise.all([
        dispatch(fetchGlobalSettings()),
        dispatch(fetchShopifyProducts()),
        dispatch(fetchContentfulProducts()),
        dispatch(fetchOrCreateCheckout(checkoutId))
      ]);

      const timeout = new Promise((resolve, reject) => {
        setTimeout(() => reject("Timeout"), 10000);
      });

      const checkTimeout = Promise.race([initApp, timeout]);

      return checkTimeout.then(resolve).catch(reject);
    })
  });
